<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form
                    class="form-inline my-2 my-lg-0"
                    v-on:keypress.enter.prevent="searchData"
                >
                    <!--                    <input-->
                    <!--                        class="form-control mr-sm-2"-->
                    <!--                        type="search"-->
                    <!--                        v-model="search.code"-->
                    <!--                        placeholder="รหัสสินค้า"-->
                    <!--                        aria-label="Search"/>-->

                    <multiselect
                        style="height: 100%"
                        v-model="search.special"
                        class="form-control border-0"
                        :options="optionTypeSpecial"
                        placeholder="หมวดหมู่สินค้า(เฉพาะ)"
                        label="name"
                        :close-on-select="true"
                        multiple
                        :searchable="true"
                        track-by="id"
                    >
                    </multiselect>
                    &nbsp
                    <multiselect
                        style="height: 100%"
                        v-model="search.code"
                        class="form-control border-0"
                        :options="optionProducts"
                        :customLabel="LabelSkuWithName"
                        placeholder="ค้นหาสินค้า"
                        :show-labels="false"
                        :close-on-select="false"
                        multiple
                        :searchable="true"
                        track-by="id"
                    >
                    </multiselect>
                    &nbsp

                    <select class="form-control" v-model="search.type">
                        <option
                            v-for="options in optionProductType"
                            :value="options.value"
                            >{{ options.text }}
                        </option>
                    </select>
                    &nbsp; &nbsp;
                    <select class="form-control" v-model="search.active">
                        <option
                            v-for="options in optionActive"
                            :value="options.value"
                            >{{ options.text }}
                        </option>
                    </select>
                    &nbsp; &nbsp;
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchData"
                    >
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp&nbsp
                    <template v-if="canInventoryProductsUpdate">
                        <router-link to="/products-information">
                            <button
                                class="btn btn-warning my-2 my-sm-0"
                                type="button"
                            >
                                <icon name="plus"></icon>
                                เพิ่มสินค้า
                            </button>
                        </router-link>
                    </template>
                    &nbsp&nbsp
                    <button
                        @click="showPrintProductPriceModal"
                        class="btn btn-primary my-2 my-sm-0"
                        type="button"
                    >
                        <icon name="print"></icon>
                        พิมพ์ใบเสนอราคา
                    </button>
                    &nbsp&nbsp
                    <button
                        @click="showPastProductPriceModal"
                        class="btn btn-primary my-2 my-sm-0"
                        type="button"
                    >
                        <icon name="print"></icon>
                        รายงานสินค้าย้อนหลัง
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">สถานะยกเลิก</th>
                        <th scope="col">สถานะสินค้า</th>
                        <template
                            v-if="
                                canInventoryProductsImport ||
                                    accessUserSpecial.includes(user.username)
                            "
                        >
                            <th scope="col">นำเข้าสินค้า</th>
                        </template>
                        <template
                            v-if="
                                canInventoryProductsExport ||
                                    accessUserSpecial.includes(user.username)
                            "
                        >
                            <th scope="col">นำออกสินค้า</th>
                        </template>
                        <th scope="col">รหัสสินค้า</th>
                        <th scope="col">ชื่อสินค้า</th>
                        <th scope="col">จำนวนคงเหลือ</th>
                        <template
                            v-if="
                                canInventoryProductsPriceView &&
                                    canInventoryProductsDetailView
                            "
                        >
                            <th scope="col">ราคาขาย/หน่วย</th>
                        </template>
                        <template v-if="canInventoryProductsDetailView">
                            <th scope="col">วันที่อัพเดตล่าสุด</th>
                        </template>
                        <template v-if="canInventoryProductsDetailView">
                            <th scope="col">หมายเหตุ</th>
                        </template>
                        <template v-if="canInventoryProductsUpdate">
                            <th scope="col">แก้ไข</th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="data in productlist">
                        <td>
                            <span v-if="data.cancel_status" style="color: red;"
                                >InActive</span
                            >
                            <span v-else style="color: green;">Active</span>
                        </td>
                        <td>
                            <icon
                                v-if="data.quantity <= data.min_quantity"
                                name="circle"
                                style="color: red;"
                            ></icon>
                            <icon
                                v-else
                                name="circle"
                                style="color: green;"
                            ></icon>
                        </td>
                        <template
                            v-if="
                                canInventoryProductsImport ||
                                    accessUserSpecial.includes(user.username)
                            "
                        >
                            <td>
                                <a @click="showImportModal(data.id)">
                                    <img
                                        src="@/assets/plus_icon.png"
                                        width="40px"
                                    />
                                </a>
                            </td>
                        </template>
                        <template
                            v-if="
                                canInventoryProductsExport ||
                                    accessUserSpecial.includes(user.username)
                            "
                        >
                            <td>
                                <a @click="showExportModal(data.id)">
                                    <img
                                        src="@/assets/delete_icon.png"
                                        width="40px"
                                    />
                                </a>
                            </td>
                        </template>
                        <td>{{ data.sku }}</td>
                        <td>{{ data.name }}</td>
                        <td>
                            {{ data.quantity | amount }}
                        </td>
                        <template
                            v-if="
                                canInventoryProductsPriceView &&
                                    canInventoryProductsDetailView
                            "
                        >
                            <td>{{ data.price | currency }}</td>
                        </template>
                        <template v-if="canInventoryProductsDetailView">
                            <td>
                                {{
                                    data.updated_at
                                        | moment("DD/MM/YYYY , HH:mm:ss")
                                }}
                            </td>
                        </template>
                        <template
                            v-if="canInventoryProductsDetailView && data.remark"
                        >
                            <td>{{ data.remark }}</td>
                        </template>
                        <template v-else-if="canInventoryProductsDetailView">
                            <td></td>
                        </template>
                        <template v-if="canInventoryProductsUpdate">
                            <td>
                                <a @click="goToProductInformation(data.id)">
                                    <icon name="pencil-alt"></icon>
                                </a>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--pagination--->
        <div v-if="productlist.length > 0">
            <vue-pagination
                :pagination="dataPaginate"
                @paginate="getProductsPage"
            >
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading
                :status="status"
                :msg="msg"
                @submit="hideLoadingModal"
            ></loading>
        </b-modal>
        <!-- Modal import products -->
        <b-modal hide-footer ref="import_data" id="import" title="นำเข้าสินค้า">
            <import-data @submit="saveImportProduct"></import-data>
        </b-modal>
        <!-- Modal Export Products -->
        <b-modal hide-footer ref="export_data" id="import" title="นำออกสินค้า">
            <export-data @submit="saveExportProduct"></export-data>
        </b-modal>
        <b-modal hide-header hide-footer ref="print_product_price">
            <add-price-product-modal
                @submit="printProductPrice"
            ></add-price-product-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="past_product_price">
            <h4>แสดงจำนวน สินค้าย้อนหลัง</h4>
            <br />
            <div class="row">
                <div class="col-3">รหัสสินค้า</div>
                <div class="col-9">
                    <multiselect
                        style="height: 100%"
                        v-model="past.code"
                        class="form-control border-0 mr-sm-2 p-0"
                        :options="optionProducts"
                        :customLabel="LabelSkuWithName"
                        placeholder="ค้นหาสินค้า"
                        :show-labels="false"
                        :close-on-select="false"
                        multiple
                        :searchable="true"
                        track-by="id"
                    >
                    </multiselect>
                    &nbsp
                </div>
            </div>
            <div class="row">
                <div class="col-3">วันที่อัพเดต</div>
                <div class="col-9">
                    <date-picker
                        class="w-100"
                        v-model="past.date"
                        type="datetime"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        confirm
                        placeholder="วันที่อัพเดต"
                    >
                    </date-picker>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-3">ประเภทสินค้า</div>
                <div class="col-9">
                    <multiselect
                        multiple
                        placeholder="เลือกประเภทสินค้า"
                        :customLabel="customLabelType"
                        track-by="value"
                        :options="optionProductType"
                        v-model="past.product_type"
                    >
                    </multiselect
                    >&nbsp;
                </div>
            </div>
            <button
                type="button"
                class="btn btn-primary my-2 my-sm-0 offset-3"
                @click="pastReportExcel"
            >
                <icon name="file-download"></icon>
                พิมพ์ Excel
            </button>
            &nbsp
            <button
                type="button"
                class="btn btn-primary my-2 my-sm-0"
                @click="pastReportPDF"
            >
                <icon name="file-download"></icon>
                พิมพ์ PDF
            </button>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ product }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import FormTextarea from "bootstrap-vue/src/components/form-textarea/form-textarea";
import ImportData from "../Import/ImportData";
import ExportData from "../Export/ExportData";
import VuePagination from "../../Pagination";
import { domain } from "../../../util/Constants";
import AddPriceProductModal from "../../Order/Overview/AddPriceProductModal";

import {
    canInventoryProductsDetailView,
    canInventoryProductsExport,
    canInventoryProductsImport,
    canInventoryProductsPriceView,
    canInventoryProductsUpdate
} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";
import moment from "moment";
import DatePicker from "vue2-datepicker";

export default {
    name: "products-list",
    components: {
        Loading,
        VuePagination,
        ExportData,
        ImportData,
        FormTextarea,
        Multiselect,
        AddPriceProductModal,
        DatePicker
    },
    data() {
        return {
            msg: "",
            status: "",
            id: "",
            option: [{ text: "หมวดหมู่สินค้า", value: "" }],
            event_submit: false,
            optionActive: [
                { text: "แสดงทั้งหมด", value: "all" },
                { text: "Active", value: "1" },
                { text: "InActive", value: "0" }
            ],
            past: {
                code: [],
                date: [],
                product_type: ""
            },
            accessUserSpecial: ["10228", "10701", "10223", "20648", "10502"],
            changeFormat: {
                stringify: date => {
                    let date_moment = moment(date).format("YYYY");
                    const year = parseInt(date_moment) + 543;
                    return date
                        ? moment(date).format("DD/MM/" + year + " HH:mm:ss")
                        : null;
                },
                parse: value => {
                    return value
                        ? moment(value, "DD/MM/YYYY HH:mm:ss")
                              .subtract(543, "y")
                              .toDate()
                        : null;
                }
            },
            lang: {
                days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
                months: [
                    "มกราคม",
                    "กุมภาพันธ์",
                    "มีนาคม",
                    "เมษายน",
                    "พฤษภาคม",
                    "มิถุนายน",
                    "กรกฎาคม",
                    "สิงหาคม",
                    "กันยายน",
                    "ตุลาคม",
                    "พฤศจิกายน",
                    "ธันวาคม"
                ],
                pickers: [
                    "ถัดไป 7 วัน",
                    "ถัดไป 30 วัน",
                    "ก่อนหน้า 7 วัน",
                    "ก่อนหน้า 30 วัน"
                ],
                placeholder: {
                    date: "วว/ดด/ปปปป"
                }
            },
            product: []
        };
    },
    created() {
        this.$store.dispatch("Products/clearSearch");
        this.$store.dispatch("Products/setProducts");
        this.$store.dispatch("ProductType/productForStock");
        this.$store.dispatch("ProductType/productTypeSpecial");
        // .then(res=>{
        // this.product = res.data;
        // this.dataPaginate = {
        //     current_page : res.current_page,
        //     from : res.form,
        //     last_page : res.last_page,
        //     per_page : res.per_page,
        //     total : res.total,
        //     to : res.to
        // }
        // });
        this.$store.dispatch("ProductType/get");
    },
    computed: {
        canInventoryProductsImport,
        canInventoryProductsExport,
        canInventoryProductsPriceView,
        canInventoryProductsDetailView,
        canInventoryProductsUpdate,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProductType: state => {
                return [
                    {
                        value: "",
                        text: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            search: state => {
                return state.Products.search;
            },
            productlist: state => {
                return state.Products.productList;
            },
            dataPaginate: state => {
                return state.Products.dataPaginate;
            },
            optionProducts: state => {
                return state.ProductType.product;
            },
            optionTypeSpecial: state => {
                return state.ProductType.productTypeSpecial;
            }
        })
    },
    methods: {
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.name}`;
            }
        },
        pastReportExcel() {
            if (this.past.date.length == 0) {
                alert("กรุณาเลือกวันที่นำออก ที่ต้องการพิมพ์");
            } else {
                let date_start = moment(this.past.date[0]).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                let date_end = moment(this.past.date[1]).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                // let code = this.past.code;
                let product_id = "";
                this.past.code.forEach((v, i) => {
                    i > 0 ? (product_id += "," + v.id) : (product_id += v.id);
                });
                let type_id = "";
                if (this.past.product_type) {
                    this.past.product_type.forEach((x, i) => {
                        if (i > 0) type_id += "," + x.value;
                        else type_id += x.value;
                    });
                }
                window.open(
                    domain +
                        "/past-export-product" +
                        "?date_start=" +
                        date_start +
                        "&date_end=" +
                        date_end +
                        "&code=" +
                        product_id +
                        "&type_id=" +
                        type_id +
                        "&file=excel"
                );
            }
        },
        pastReportPDF() {
            //console.log(this.past.date)
            if (this.past.date.length == 0) {
                alert("กรุณาเลือกวันที่นำออก ที่ต้องการพิมพ์");
            } else {
                let date_start = moment(this.past.date[0]).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                let date_end = moment(this.past.date[1]).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
                // let code = this.past.code;
                let product_id = "";
                this.past.code.forEach((v, i) => {
                    i > 0 ? (product_id += "," + v.id) : (product_id += v.id);
                });
                let type_id = "";
                if (this.past.product_type) {
                    this.past.product_type.forEach((x, i) => {
                        if (i > 0) type_id += "," + x.value;
                        else type_id += x.value;
                    });
                }
                window.open(
                    domain +
                        "/past-export-product" +
                        "?date_start=" +
                        date_start +
                        "&date_end=" +
                        date_end +
                        "&code=" +
                        product_id +
                        "&type_id=" +
                        type_id +
                        "&file=pdf"
                );
            }
        },
        customLabelType(option) {
            return `${option.text}`;
        },
        //Modal
        showImportModal(id) {
            this.id = id;
            this.showProduct(id);
            this.$refs.import_data.show();
        },
        showExportModal(id) {
            this.id = id;
            this.showProduct(id);
            this.$refs.export_data.show();
        },
        hideImportModal() {
            this.$refs.import_data.hide();
        },
        hideExportModal() {
            this.$refs.export_data.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        //API
        showProduct(id) {
            this.$store.dispatch("Products/show", id);
        },
        goToProductInformation(id) {
            this.$store.dispatch("Products/show", id).then(() => {
                this.$router.push({
                    name: "products-information",
                    params: { id }
                });
            });
        },
        searchData() {
            this.event_submit = true;
            if (this.search.type === null) {
                this.search.type = "";
            }
            let product_id = "";
            if (this.search.code.length > 0) {
                this.search.code.forEach((v, i) => {
                    i > 0 ? (product_id += "," + v.id) : (product_id += v.id);
                });
            }
            let product_type_special = "";
            if (this.search.special.length > 0) {
                this.search.special.forEach((v, i) => {
                    i > 0
                        ? (product_type_special += "," + v.id)
                        : (product_type_special += v.id);
                });
            }
            this.$store.dispatch("Products/searchWithSpecial", {
                code: product_id,
                type: this.search.type,
                active: this.search.active,
                special: product_type_special
            });
        },
        saveImportProduct(submitData) {
            if (submitData !== 1) {
                this.$store
                    .dispatch("ImportProduct/create", submitData)
                    .then(() => {
                        this.getProductsPage();
                        this.hideImportModal();
                    });
            }
            this.hideImportModal();
        },
        saveExportProduct(submitData) {
            if (submitData !== 1) {
                //console.log(submitData)
                return this.$store
                    .dispatch("ExportProduct/create", submitData)
                    .then(data => {
                        if (!data) {
                            alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร");
                        } else {
                            this.getProductsPage();
                            this.hideExportModal();
                        }
                    });
            }
            this.hideExportModal();
        },
        getProductsPage() {
            const page = this.dataPaginate.current_page;
            this.showLoadingModal();
            this.status = 1;
            this.msg = "กำลังดาวโหลดข้อมล";
            //paginate search
            if (this.event_submit) {
                this.$store
                    .dispatch("Products/search", {
                        page: page,
                        code: this.search.code,
                        type: this.search.type
                    })
                    .then(() => {
                        this.hideLoadingModal();
                    });
            } else {
                //paginate get data
                this.$store.dispatch("Products/setProducts", page).then(() => {
                    this.hideLoadingModal();
                });
            }
        },
        printProductPrice(value) {
            if (value) {
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = "กำลังเรียกรายงาน กรุณารอสักครู่";
                let data = {
                    add_foam: value.add_price_foam,
                    add_other: value.add_price_other,
                    product_type_id: value.product_type_id,
                    promotionOption: value.promotionOption,
                    promotionOption_type: value.promotionOption_type,
                    pack_type: value.pack_type
                };
                this.$store
                    .dispatch("Products/printProductPromotion", data)
                    .then(res => {
                        this.showLoadingModal();
                        this.status_loading = 2;
                        this.msg = "สำเร็จ";
                        window.open(res);
                    });
            }
            this.hidePrintProductPriceModal();
        },
        showPrintProductPriceModal() {
            this.$refs.print_product_price.show();
        },
        hidePrintProductPriceModal() {
            this.$refs.print_product_price.hide();
        },
        showPastProductPriceModal() {
            this.$refs.past_product_price.show();
        },
        hidePastProductPriceModal() {
            this.$refs.past_product_price.hide();
        }
    }
};
</script>

<style lang="scss" scoped></style>
